import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Instagram, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-blue-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo e Descrição */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_gotelip-ms/artifacts/dfe60gnc_image_2026-03-14_140126446.png" 
                alt="Gotelip Assistência" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <div className="text-lg font-bold text-blue-400">GOTELIP</div>
                <div className="text-xs text-blue-300/80">ASSISTÊNCIA TÉCNICA</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Especialistas em manutenção e reparo de computadores, notebooks e celulares. 
              Qualidade e confiança no atendimento.
            </p>
          </div>

          {/* Contato */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-blue-400">Contato</h3>
            <div className="space-y-3">
              <a
                href={`https://wa.me/${contactInfo.whatsapp}?text=${encodeURIComponent(contactInfo.message)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-blue-400 transition-colors group"
              >
                <Phone size={18} className="group-hover:scale-110 transition-transform" />
                <span className="text-sm">67 98155-6252</span>
              </a>
              <a
                href={`https://instagram.com/${contactInfo.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-blue-400 transition-colors group"
              >
                <Instagram size={18} className="group-hover:scale-110 transition-transform" />
                <span className="text-sm">@{contactInfo.instagram}</span>
              </a>
              <div className="flex items-center space-x-3 text-gray-300">
                <MapPin size={18} />
                <span className="text-sm">{contactInfo.location}</span>
              </div>
            </div>
          </div>

          {/* Horário */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-blue-400">Horário de Atendimento</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex justify-between">
                <span>Segunda - Sexta:</span>
                <span className="text-gray-300">8h - 18h</span>
              </div>
              <div className="flex justify-between">
                <span>Sábado:</span>
                <span className="text-gray-300">8h - 12h</span>
              </div>
              <div className="flex justify-between">
                <span>Domingo:</span>
                <span className="text-gray-300">Fechado</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-blue-900/30 text-center space-y-3">
          <div className="flex justify-center gap-6">
            <Link to="/privacidade" className="text-sm text-gray-500 hover:text-blue-400 transition-colors">
              Política de Privacidade
            </Link>
            <span className="text-gray-700">•</span>
            <Link to="/contato" className="text-sm text-gray-500 hover:text-blue-400 transition-colors">
              Contato
            </Link>
          </div>
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Gotelip Assistência Técnica. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
